import styles from "../../../../styles/patient-page-modules/readingModal.module.css";
import { formatDate, convertUTCToLocal } from "../../../../utils/helper";

export const pulseOXColumns = [
  {
    key: "reading_dates",
    label: "Reading Dates",
    alignLeft: true,
    // SCRUM-989: the rows have no "reading_dates" field, so the sort arrows
    // need the date shown (date and time).
    sortField: "recorded_at",
    render: (reading) => convertUTCToLocal(reading.recorded_at),
  },
  {
    key: "oxygen",
    label: "Oxygen",
    render: (reading) => (
      <div className={styles.condition}>
        <div
          className={styles.condition_mark}
          style={{
            backgroundColor:
              reading.oxygen < 120
                ? "green"
                : reading.oxygen < 130
                ? "yellow"
                : "red",
            borderColor:
              reading.oxygen < 120
                ? "greenyellow"
                : reading.oxygen < 130
                ? "gold"
                : "orange",
          }}
        ></div>{" "}
        {reading.oxygen} %
      </div>
    ),
  },
  {
    key: "heart_rate",
    label: "Heart Rate",
    render: (reading) => (
      <div className={styles.condition}>
        <div
          className={styles.condition_mark}
          style={{
            backgroundColor:
              reading.heart_rate < 80
                ? "green"
                : reading.heart_rate < 90
                ? "yellow"
                : "red",
            borderColor:
              reading.heart_rate < 80
                ? "greenyellow"
                : reading.heart_rate < 90
                ? "gold"
                : "orange",
          }}
        ></div>{" "}
        {reading.heart_rate} bpm
      </div>
    ),
  },
  // {
  //   key: "pulse",
  //   label: "Pulse",
  //   render: (reading) => (
  //     <div className={styles.condition}>
  //       <div
  //         className={styles.condition_mark}
  //         style={{
  //           backgroundColor:
  //             reading.pulse >= 60 && reading.pulse <= 80
  //               ? "green"
  //               : reading.pulse < 60 || reading.pulse > 100
  //               ? "red"
  //               : "yellow",
  //           borderColor:
  //             reading.pulse >= 60 && reading.pulse <= 80
  //               ? "greenyellow"
  //               : reading.pulse < 60 || reading.pulse > 100
  //               ? "orange"
  //               : "gold",
  //         }}
  //       ></div>{" "}
  //       {reading.pulse} bpm
  //     </div>
  //   ),
  // },
];
